import React from 'react';

import cn from 'classnames';
import { BBCommonProps, BBEditableModeProps } from 'types/story';
import withCardTransitionContext from 'client/components/common/BuildingBlocks/BuildingBlockEnhancer';
import css from 'src/routes/client/components/common/BuildingBlocks/Answer/ResultText/ResultText.scss';
import AnimatedCounter from 'common/components/AnimatedCounter';

type Props = BBCommonProps;

class ResultText extends React.Component<Props> {
	renderEditable() {
		return this.renderDefault(this.props.editableModeProps?.nodeProps);
	}

	renderDefault(props: Partial<BBEditableModeProps['nodeProps']> = {}) {
		const { nodeProps } = this.props.uiConfig;
		const { isEditableMode, answerVote } = this.props;
		const start = isEditableMode ? 100 : 0;
		const isHidden = isEditableMode ? false : !answerVote?.isShow;

		return (
			<div
				{...nodeProps}
				{...this.props.stateAttrs}
				{...this.props.eventListeners}
				{...props}
				className={cn(css.text, nodeProps.className)}
			>
				<div className={cn(css.counter, { [css.hidden]: isHidden })}>
					<AnimatedCounter
						animate={answerVote?.isShow}
						duration={answerVote?.duration}
						start={start}
						end={answerVote?.value || start}
					/>
					%
				</div>
			</div>
		);
	}

	render() {
		return this.props.isEditableMode ? this.renderEditable() : this.renderDefault();
	}
}

export default withCardTransitionContext(ResultText);
